module.exports = __webpack_public_path__ + "static/media/jpg.bbc1878b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/jpg.svg
// module id = 598
// module chunks = 0